// /client/src/components/Breadcrumb.js

import React from 'react';
import { Breadcrumb as BootstrapBreadcrumb } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();

  // Split the location path into an array of segments
  const pathnames = location.pathname.split('/').filter((x) => x);
  const filteredPathnames = pathnames.filter(x => isNaN(Number(x)));
  console.log({ pathnames, filteredPathnames });
  // If the user is on the home page, do not display the breadcrumb
  if (location.pathname === '/') return null;

  return (
    <BootstrapBreadcrumb>
      <BootstrapBreadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
        Home
      </BootstrapBreadcrumb.Item>
      {filteredPathnames.map((value, index) => {
        const to = `/${filteredPathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === filteredPathnames.length - 1;
        const properCase = value
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        return isLast ? (
          <BootstrapBreadcrumb.Item active key={to}>
            {properCase}
          </BootstrapBreadcrumb.Item>
        ) : (
          <BootstrapBreadcrumb.Item linkAs={Link} linkProps={{ to }} key={to}>
            {properCase}
          </BootstrapBreadcrumb.Item>
        );
      })}
    </BootstrapBreadcrumb>
  );
};

export default Breadcrumb;
